import React from 'react'
import map from 'lodash/map'
import type { OrderItemRow } from './OrderItemRow'
import { formatMoney } from '@ztechapps/common.utils'
import { HorizontalStack } from '@ztechapps/webui.util'
import { ProductCardSmall } from '../../components/ProductCardSmall'
import { AtPricePerUom } from '../../components/OrderPriceWrap'

export const OrderItemsLarge = ({ items }: { items: OrderItemRow[] }) => {
  return (
    <div className="d-none d-lg-block">
      <table className="table table-hover table-responsive-lg">
        <thead>
          <tr className="table-secondary">
            <th>Product</th>
            <th>Qty. & Price</th>
            <th>Price</th>
          </tr>
        </thead>

        <tbody>
          {map(items, ({ product, _id, net, price, quantity, uom, ...rest }, index) => (
            <tr key={_id ?? index}>
              <td>
                <ProductCardSmall {...product} />
                <small className={'text-warning'}>{rest?.remarks}</small>
              </td>
              <td>
                <HorizontalStack gap={1}>
                  {quantity}
                  <AtPricePerUom price={price} uom={uom?.name} />
                </HorizontalStack>
              </td>
              <td>
                <div>{formatMoney(net)} </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
